<!--
 * @Author: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @Date: 2024-07-14 12:05:24
 * @LastEditors: 岁岁平岁岁安·岁岁平安 1350797548@qq.com
 * @LastEditTime: 2024-07-14 19:13:36
 * @FilePath: \pc\coursearrange\src\dataBoard\dataBoard.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->


<template>
    <div style="padding: 20px 0px 0px 20px;">
      <div>
        <!-- <span class="el-icon-circle-close"  style="font-size: 28px;    text-align: end;   position: absolute;  right: 30px;  margin-top: -60px;" @click="goBack"  ></span> -->
      </div>
  
        <el-form style="display: flex;flex-wrap: wrap;">


              <el-form-item label="学生:" style="display: flex;width: 33%;">
                  <el-select placeholder="请选择学生" v-model="text" style="width: 100%" clearable filterable>
                      <el-option v-for="item in options"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item label="性别:" style="display: flex;width: 33%;">
                <el-select v-model="text1" style="width:100%;" placeholder="请选择性别" filterable >
                     <el-option v-for="item in classTypsArr1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="年级:" style="display: flex;width: 33%;">
                <el-cascader clearable style="width: 100%;" v-model="text2" :options="gradeList"  :props="props"></el-cascader>
              </el-form-item>

              <el-form-item label="学生类型:" style="display: flex;width: 33%;">
                <el-select v-model="text3" style="width:100%;" placeholder="请选择学生类型" filterable >
                     <el-option v-for="item in classTypsArr111" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="课程:" style="display: flex;width: 33%;">
                <el-select v-model="text4" style="width:100%;" placeholder="请选择课程" filterable >
                     <el-option  v-for="item in subjectArr" :key="item.id" :value="item.id"  :label="item.categoryName"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="学生状态:" style="display: flex;width: 33%;">
                <el-select v-model="text5" style="width:100%;" placeholder="请选择学生状态" filterable >
                     <el-option v-for="item in classTypsArr11111" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="首次课日期:" style="display: flex;width: 100%;">
                  <el-date-picker
                    style="width: 100%;"
                    v-model="dateTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable>
                    </el-date-picker>
              </el-form-item>

           
              <div style="display: flex;justify-content: end;width: 100%;margin-bottom: 30px; margin-top: 6px;">
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
                <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-arrow-left" @click="goBack">返回上一级</el-button>
              </div>
  
        </el-form>
  
  
          <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="700">
              <el-table-column prop="studentName" label="学生" show-overflow-tooltip></el-table-column>
              <el-table-column prop="sex" label="性别" show-overflow-tooltip></el-table-column>
              <el-table-column prop="gradeName" label="年级" show-overflow-tooltip></el-table-column>
              <el-table-column prop="classType" label="学生类型" show-overflow-tooltip></el-table-column>
              <el-table-column prop="categoryName" label="课程" show-overflow-tooltip></el-table-column>
              <el-table-column prop="classStatus" label="学生状态" show-overflow-tooltip></el-table-column>
              <el-table-column prop="classNum" label="已上课结数" show-overflow-tooltip></el-table-column>
              <el-table-column prop="lossReason" label="流失原因" show-overflow-tooltip></el-table-column>
              <el-table-column prop="firstClassDate" label="首次课日期" show-overflow-tooltip width="150"></el-table-column>
          </el-table>
  
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="pageNum" :page-size="pageSize"
              layout="prev, pager, next,sizes, jumper" :total="total">
          </el-pagination>

    </div>
  </template>
  
  
  <script>
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import { handleStudent, handleTeacher } from "../utils/publicInterface";
  import { getStudentsType } from "@/api/fiveClassApi"
  import { getTeachers } from "@/api/fiveClassApi"
  import { ApiGetStudentList, } from "@/api/apiTask";
  import { getSubject } from "@/api/fiveClassApi"

  export default {
    components:{
  
    },
    data() {
        return{
            text:'',
            text1:'',
            text2: [],
            text3:'',
            text4:'',
            text5:'',

            dateTime:[],
  
            options:[],
            options1:[{id:1,realname:'初级老师'},{id:2,realname:'中级老师'},{id:3,realname:'高级老师'},{id:4,realname:'特级老师'}],
            options2:[{id:1,realname:'待审批'},{id:2,realname:'审批中'},{id:3,realname:'驳回'},{id:4,realname:'已完成'}],
  
            input1:'',
            input2:'',
            input3:'',
            dataList:[],
  
            pageNum: 1,
            pageSize: 10,
            total: 0,
  
            form:{
                input1:'',
                input2:true,
                input3:'',
            },
  
            titleDialogShowvisible:false,
            titleDialogShowvisible1:false,
            textareainput:'',
  
            fromlabel:'',
            placeholderfrom:'',
            titleDialogShowvisibletitle1:'',
            
            optionsListt:[],
            getStudentsArr_s:[],
            subjectArr:[],

            props: {
              label: "gradeName",
              children: "children",
              value: "id"
            },

            input4:'',
            input5:'',
            input6:'',

            classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],

            classTypsArr1:[
              { label: '男', value: 1 },
              { label: '女', value: 2 },
            ],
            classTypsArr11:[
              { label: '异常', value: 1 },
              { label: '无异常', value: 2 },
            ],
            classTypsArr111:[
              { value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }
            ],
            classTypsArr1111:[
              { label: '异常', value: 1 },
              { label: '无异常', value: 2 },
            ],
            classTypsArr11111:[
              { label: '流失', value: 1 },
              { label: '在读', value: 2 },
              { label: '结业', value: 3 },
            ],

            gradeList: [],
            teacherId: '',
        }
    },
  
    mounted(){

      this.teacherId = this.$route.params.id


   
      getStudentsType(0).then(_res => {
        //  getStudentsType(2).then(res => {
          this.options = _res.data
        // })
      })


      // getTeachers().then(res => {  this.options = res.data })

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,  { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }  }).then((res)=>{ this.optionsListt = res.data.data})
      ApiGetStudentList().then((res) => {  let { data } = res; this.getStudentsArr_s = data;  });

      getSubject().then(res => {   this.subjectArr = res.data   })

      axios.get(`${apiBaseUrl}/grade/getGrade`,{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }).then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.getApiList()
    },
  
  
    methods:{

        highlightRow (id,index) {
          this.$router.push({path:`/student-detail/${id}/${1}`, })
        },


        getApiList(){
            let data = {
                pageNo: this.pageNum,
                pageSize: this.pageSize,
                studentId: this.text,
                sex: this.text1,
                gradeList: this.text2.length > 0 ? this.text2.join(',')  : [],
                classType: this.text3,
                categoryId: this.text4,
                studentStatus: this.text5,
                firstClassDateStart: this.dateTime.length > 0 ? this.dateTime[0] : '',
                firstClassDateEnd:this.dateTime.length > 0 ? this.dateTime[1] : '',
                teacherId: this.teacherId,
            }
            axios.post(`${apiBaseUrl}/teacher/findJobTeacherInfo`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
  
                  if(res.data.code === 200){
  
                    let data = res.data.data
                    this.dataList = data.list
                    // this.pageNum = data.current ? data.current : 0
                    // this.pageSize = data.size ? data.size : 10
                    this.total = data.allTotal
  
                    this.$message({ message: res.data.message , type: "success" })
                  }else{
                    this.dataList = []
                    this.total = 0
                    this.$message({ message: res.data.message , type: "error" })
                  }
            }).catch((err)=>{
                this.dataList= []
                this.pageSize = 10
                this.pageNum = 1
                this.total = 0
                this.$message({ message: err , type: "error" })
            })
        },
  
  
        titlerejectDialogShowClr(){
          this.titleDialogShowvisible = false
        },
  
        titlerejectDialogShowClr1(){
          this.textareainput = ''
          this.titleDialogShowvisible1 = false
        },
  
        titlerejectDialogShowSubt1(){
          if(this.textareainput){
            this.textareainput = ''
            this.titleDialogShowvisible1 = false
          }else{
            this.$message({ message: '请填写备注~' , type: "warning" })
          }
        },
  
        searchBtns(){
            this.getApiList()
        },

        exportBtns(){
            let data = {
                pageNo: this.pageNum,
                pageSize: this.pageSize,
                studentId: this.text,
                sex: this.text1,
                gradeList: this.text2.length > 0 ? this.text2.join(',')  : [],
                classType: this.text3,
                categoryId: this.text4,
                studentStatus: this.text5,
                firstClassDateStart: this.dateTime.length > 0 ? this.dateTime[0] : '',
                firstClassDateEnd:this.dateTime.length > 0 ? this.dateTime[1] : '',
                teacherId: this.teacherId,
            }
            axios.post(`${apiBaseUrl}/teacher/exportJobTeacherInfo`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
                if(response.status == 200){
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                    const downloadLink = document.createElement("a");
                    downloadLink.href = URL.createObjectURL(blob);
                    downloadLink.download = "在职教师详情.xlsx"; 
                    downloadLink.click();
                    this.$message({ message: res.data.message , type: "success" })
                }
                else{
                    this.$message({ message: res.data.message , type: "error" })
                }
            })
        },
  
        clearBtns(){
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''
            this.dateTime = []

            this.text = ''
            this.text1 = ''
            this.text2 = []
            this.text3 = ''
            this.text4 = ''
            this.text5 = ''

            this.pageNum = 1
            this.pageSize = 10
            this.total = 0

            this.getApiList()
        },

        goBack() {
          history.go(-1);
        },
  
        handleSizeChange(e){
            this.pageSize = e
            this.getApiList()
        },
  
        handleCurrentChange(e){
            this.pageNum = e
            this.getApiList()
        },
  
        handleClickView(type,itme){
          console.log(itme)
          if(type === 2){
            this.titleDialogShowvisible = true
          }
          if(type === 1){
            this.titleDialogShowvisible = true
          }
  
        },
  
        titlerejectDialogShowClrB(){
          this.titleDialogShowvisibletitle1 = '审批意见'
          this.fromlabel = '备注：'
          this.placeholderfrom = '请输入意见'
          this.titleDialogShowvisible1 = true
        },
        titlerejectDialogShowClrS(){
          this.titleDialogShowvisibletitle1 = '驳回原因'
          this.fromlabel = '驳回原因：'
          this.placeholderfrom = '请输入驳回原因'
          this.titleDialogShowvisible1 = true
        },
    }
  
  }
  </script>
  
  
  <style scoped lang="less">
  
    .no-click {
        pointer-events: none;
    }
  
    .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }
  
  
  </style>
  


// WEBPACK FOOTER //
// src/TeacherManagement/theJobTeacherDetails.vue